/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsBulkOperationsRestoreAllFromArchiveDesktopModel,
  IChatsBulkOperationsRestoreAllFromArchiveDesktopRequest,
  IMappers,
  IChatsBulkOperationsRestoreAllFromArchiveDesktopResponse,
  IChatsBulkOperationsRestoreAllFromArchiveDesktopResponseError,
  TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse,
} from './types';

const defaultConfig: TChatsBulkOperationsRestoreAllFromArchiveDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/bulk-operations/restore-all-from-archive-desktop/',
  hostType: 'api',
} as TChatsBulkOperationsRestoreAllFromArchiveDesktopModel;

function createChatsBulkOperationsRestoreAllFromArchiveDesktopModel(
  parameters: IChatsBulkOperationsRestoreAllFromArchiveDesktopRequest,
): TChatsBulkOperationsRestoreAllFromArchiveDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsBulkOperationsRestoreAllFromArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsBulkOperationsRestoreAllFromArchiveDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsBulkOperationsRestoreAllFromArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsBulkOperationsRestoreAllFromArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createChatsBulkOperationsRestoreAllFromArchiveDesktopModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsBulkOperationsRestoreAllFromArchiveDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsBulkOperationsRestoreAllFromArchiveDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse;
}

export {
  defaultConfig,
  createChatsBulkOperationsRestoreAllFromArchiveDesktopModel,
  fetchChatsBulkOperationsRestoreAllFromArchiveDesktop,
};
